export default __webpack_public_path__ + "static/media/glenfernmultistoreyimg1.f86dc501.png";